import './style.scss';

import React, { Fragment } from 'react';
import _ from 'lodash';
import Modal from 'react-modal';
import { getRelatedProducts } from 'shared/models/api';
import PriceDisplay from 'shared/components/product/priceDisplay';
import ProductQtySelector from 'scy/QtySelector';
import QtyDiscount from 'shared/components/product/qtyDiscount';
import { MediumCarousel } from 'scy/Carousel';
import productStyles from 'components/product/styles.mod.scss';
import { Body, SmallUppercase } from 'scy/text';
import { ProductGridItem } from 'scy/ProductGrid';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { OVERLAY_CLASS_NAME } from 'components/ui/modal';

class QuickView extends React.Component {
  constructor(props) {
    super(props);
    this.noop = () => {};

    this.state = {
      loadingRecommendations: false,
      recommendations: []
    };

    this.renderOption = this.renderOption.bind(this);
    this.renderValue = this.renderValue.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.changeProduct = this.changeProduct.bind(this);
    this.close = this.props.close.bind(this);
  }

  componentDidMount() {
    const sku = this.props.product && this.props.product.sku_id;
    if (sku) this.getRecommendations(sku);
  }

  componentDidUpdate(prevProps) {
    const sku = this.props.product && this.props.product.sku_id;
    const prevSku = prevProps.product && prevProps.product.sku_id;
    if (sku && sku !== prevSku) this.getRecommendations(sku);
  }

  getRecommendations(sku) {
    this.setState({ loadingRecommendations: true });
    getRelatedProducts(sku).then(({ fbt }) =>
      this.setState({
        recommendations: fbt,
        loadingRecommendations: false
      })
    );
  }

  renderOption(item) {
    return <div className="product-qty">{item.value}</div>;
  }

  renderValue(item) {
    return (
      <div className="product-qty">
        Quantity <span className="product-qty-number">{item.value}</span>
      </div>
    );
  }

  addToCart(qty) {
    return this.props.addToCart(this.props.product, qty).then(this.close);
  }

  changeProduct(product) {
    this.props.changeProduct(product);
    this.scrollable.scrollTop = 0;
  }

  render() {
    const product = this.props.product || {};

    return (
      <Modal
        overlayClassName={OVERLAY_CLASS_NAME}
        className="modal-content modal-content--quick-view"
        isOpen={!_.isEmpty(product)}
        onRequestClose={this.close}
        shouldCloseOnOverlayClick={true}
        contentLabel="View Product"
        ariaHideApp={false}
      >
        <button
          type="button"
          className="btn--inline right quick-view__cancel"
          onClick={this.close}
        >
          ×
        </button>

        <div
          className="quick-view__content"
          ref={div => (this.scrollable = div)}
        >
          <div className="row text-left">
            <div className="col-xs-12 col-sm-6">
              <img
                className="quick-view__image"
                src={product.image_large}
                alt={product.title}
              />
            </div>

            <div className="col-xs-12 col-sm-6">
              <div className={`${padding.left_sm} ${padding.right_sm}`}>
                <QuickViewSummary product={product} />

                {product.soldout ? (
                  <span className="error">Sold Out</span>
                ) : !product.price ? (
                  <span className="error">
                    Product not available at your location
                  </span>
                ) : (
                  <Fragment>
                    {!!product.package_qty && (
                      <QtyDiscount
                        product={product}
                        textProps={{ tag: 'p', weight: 'med' }}
                      />
                    )}
                    <ProductQtySelector
                      buttonText="Add to Cart"
                      buttonAction={this.addToCart}
                      mobileInline
                    />
                  </Fragment>
                )}
              </div>
            </div>
          </div>

          {!this.state.loadingRecommendations &&
            !!this.state.recommendations.length && (
              <section className="quick-view__recommendations text-left">
                <SmallUppercase
                  tag="h3"
                  marginClass={`${margin.top_sm} ${margin.bottom_sm}`}
                >
                  Often Bought With
                </SmallUppercase>
                <MediumCarousel>
                  {this.state.recommendations.map(product => (
                    <div key={product.sku_id} className={padding.right_sm}>
                      <ProductGridItem
                        product={product}
                        onContainerClick={() => this.changeProduct(product)}
                      />
                    </div>
                  ))}
                </MediumCarousel>
              </section>
            )}
        </div>
      </Modal>
    );
  }
}

export function QuickViewSummary({ product }) {
  return (
    <Fragment>
      <h1 className={productStyles.title}>{product.title}</h1>
      <Body tag="h2" marginClass={`${margin.top_0} ${margin.bottom_xs}`}>
        <span>
          {product.subtitle} | {product.volume}
        </span>
        <PriceDisplay product={product} />
      </Body>
      <Body tag="p" marginClass={`${margin.top_0} ${margin.bottom_sm}`}>
        {product.description}
      </Body>
    </Fragment>
  );
}

export default QuickView;
